import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import LogoChip from "./LogoChip";
import { PARTNER_CATEGORIES } from "../data/site";

const Partners = () => (
  <section id="partners" data-testid="partners-section" className="relative py-28 md:py-40">
    <div className="max-w-6xl mx-auto px-6">
      <SectionHeader
        index={7}
        overline="Technology Ecosystem"
        title={<>Backed by a Global<br /><span className="text-smipl-orange">Partner Ecosystem.</span></>}
        sub="We design, integrate and support across eight partner domains — with certified OEM ecosystems behind every engagement."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PARTNER_CATEGORIES.map((p, i) => (
          <Reveal key={p.id} delay={(i % 4) * 0.06}>
            <Link
              to={`/partners/${p.id}`}
              data-testid={`partner-card-${p.id}`}
              className="tracing-border group w-full h-full text-left rounded-2xl border border-white/8 bg-navy-deep/60 p-7 block transition-all duration-300 hover:-translate-y-1.5 hover:border-smipl-orange/40"
            >
              <p.icon size={22} className="text-smipl-orange" />
              <h3 className="mt-5 font-display text-base md:text-lg font-bold">{p.name}</h3>
              <p className="mt-2 text-xs md:text-sm text-slate-500 leading-relaxed">{p.blurb}</p>
              {p.partners?.length > 0 ? (
                <div className="mt-5 flex flex-wrap gap-1.5">
                  {p.partners.slice(0, 3).map((pt) => (
                    <LogoChip
                      key={pt.name}
                      name={pt.name}
                      domain={pt.domain}
                      className="rounded-lg px-2.5 py-1.5"
                      imgClass="h-4 max-w-[64px]"
                      fallbackClass="text-[11px] font-semibold text-navy-deep"
                    />
                  ))}
                  {p.partners.length > 3 && (
                    <span className="rounded-lg px-2 py-1.5 text-[11px] font-semibold text-smipl-orange">
                      +{p.partners.length - 3} more
                    </span>
                  )}
                </div>
              ) : (
                <p className="mt-5 font-mono text-[10px] tracking-[0.25em] uppercase text-slate-600 group-hover:text-smipl-orange transition-colors">
                  {p.note}
                </p>
              )}
            </Link>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15} className="mt-10">
        <Link to="/partners" data-testid="partners-view-all" className="group inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-smipl-orange hover:text-smipl-amber transition-colors">
          Explore the full ecosystem <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default Partners;
